module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/framework/spk/layouts/tabs/spk-tabs/spk-tabs.component.scss
// module id = ./src/app/components/framework/spk/layouts/tabs/spk-tabs/spk-tabs.component.scss
// module chunks = main